import {useBoolean} from 'usehooks-ts'

import {Button, Dialog} from '@sdox/ui'
import {useFragmentHelpers} from '@sdox/api'

import {getIcon, sizeMap, variantMap} from './utils'
import {SectionBlocksTemplate} from '../Section/SectionBlocksTemplate'
import {SectionContainer} from '../Section/SectionContainer'
import {PanelContext} from '../../context/PanelContext'

import type {TrackingProps} from '@sdox/utils/dom'
import type {ButtonInterface_DialogButtonType_Fragment} from '@sdox/api'

type DialogButtonProps = ButtonInterface_DialogButtonType_Fragment

export const DialogButton = (props: DialogButtonProps) => {
  const {size, label, variant, leadingIcon, trailingIcon, panelId, mboAttrs} = props
  const {usePanel} = useFragmentHelpers()
  const panel = usePanel(panelId)
  const {
    setTrue: openDialog,
    setFalse: closeDialog,
    value: isOpen,
  } = useBoolean()

  if (!panel) return null

  return (
    <>
      <Button
        size={sizeMap[size]}
        variant={variantMap[variant]}
        leading={getIcon(leadingIcon)}
        trailing={getIcon(trailingIcon)}
        onClick={openDialog}
        mboAttrs={mboAttrs as TrackingProps}
      >
        {label}
      </Button>
      <Dialog
        size={'small'}
        open={isOpen}
        onClose={closeDialog}
        title={typeof label === 'string' ? label : undefined}
      >
        <Dialog.Content>
          <Dialog.Section>
            <SectionContainer>
              <PanelContext.Provider value={{panels: [panel]}}>
                <SectionBlocksTemplate
                  blocks={panel.blocks}
                />
              </PanelContext.Provider>
            </SectionContainer>
          </Dialog.Section>
        </Dialog.Content>
      </Dialog>
    </>
  )
}
